import { customerHasFeature } from "auth/customerHasFeature"
import { AppContext } from "components/AppContextProvider"
import ButtonLink from "components/ButtonLink"
import { allRoutes } from "generated/routes"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"

interface CrisisButtonProps {
  fontSize: string
  padding: string
  margin: string
  height: string
}

const CrisisButton: React.FC<CrisisButtonProps> = ({ fontSize = "", padding = "", margin = "", height = "" }) => {
  const appContext = useContext(AppContext)
  const { t } = useTranslation()

  return (
    <>
      {customerHasFeature(appContext.appUser.customer, "CrisisManagement") && (
        <ButtonLink
          color="warning"
          variant="outlined"
          fontSize={fontSize}
          padding={padding}
          margin={margin}
          height={height}
          sx={{ marginRight: 2 }}
          route={allRoutes.CrisismanagementCrisisinfo()}>
          {t("global.in_case_of_crisis_click_here", "In crisis click here")}
        </ButtonLink>
      )}
    </>
  )
}

export default CrisisButton
